module.exports = __webpack_public_path__ + "assets/img/25_412_big.69bb33ce.jpg";